export const ru = {
    'campaign-group': 'Кампания/группа',
    'campaign-type': 'Тип кампании',
    'context-price': 'Ставка (в сетях)',
    'context-price-with-currency': 'Ставка (в сетях), {currency}',
    description: 'Примечание',
    name: 'Название',
    price: 'Max цена клика',
    status: 'Статус',
    targeting: 'Условия показа'
};
